/**
 * Factory: Slider
 */
angular.module('acme.common.factory.slider', [])
  .factory('SliderFactory', [function () {


    function Slider() {
      this.stepHistory = [];
      this.currentStep = '';
      this.currentTree = [];
      this.steps = [];

    }

    Slider.prototype = {

      constructor: Slider,

      init: function (steps) {

        if (steps instanceof Array) {
          this.steps = steps;
        }else if (steps !== null && steps === 'object') {
          this.steps = [steps];
        }

      },

      start: function (name) {
        var self = this;
        $.each(this.steps, function (i, step) {
          if (step.stepName === name) {
            if (typeof(step.sliderSteps[i].data === 'string')) {
              self.currentTree = angular.copy(step);
              self.currentStep = self.findStep(step.data);
              self.stepHistory.push(self.currentStep);
            } else {
              self.currentStep = obj.data;
            }
          }
        });
      },

      findStep: function (name) {
        var i, ii,
          r = false;

        if (this.currentTree.hasOwnProperty('sliderSteps') &&
            this.currentTree.sliderSteps instanceof Array) {
          for (i = 0, ii = this.currentTree.sliderSteps.length; i < ii; i++) {
            if (this.currentTree.sliderSteps[i].stepName === name) {
              r = this.currentTree.sliderSteps[i];
              break;
            }
          }
        }
        return r;
      },

      back: function () {
        this.stepHistory.pop();
        this.currentStep = this.findStep(this.stepHistory[this.stepHistory.length - 1].stepName);
        return this.currentStep;
      },

      getStep: function (name) {
        var nextStep = this.findStep(name);

        if (nextStep) {
          this.currentStep = nextStep;
          this.stepHistory.push(this.currentStep);
          if (typeof(this.currentStep.callback) === 'function') {
            this.currentStep.callback();
          }
        }

        return nextStep;
      }

    };

    return Slider;

  }]);